﻿import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { BaseService } from '../../lib-shared/services/base.service';
import { ResponseResult } from '../../lib-shared/models/response-result';
import { catchError } from 'rxjs/operators';


@Injectable({ providedIn: 'root' })
export class DistrictsService extends BaseService {

    constructor(http: HttpClient, injector: Injector) {
        super(http, injector, `${environment.apiDomain.dapFoodEndPoint}/Districts`);
    }

    Gets(key: string, idProvince: number, idDistrict: number, offset?: number, limit?: number, sortField?: string, isAsc: boolean = false) {
        const queryString = `${this.serviceUri}?key=${key}&idProvince=${idProvince}&idDistrict=${idDistrict}&offset=${offset}&limit=${limit}&sortField=${sortField}&isAsc=${isAsc}`;
        return this.defaultGet(queryString);
    }

    Save(item: any): Promise<ResponseResult> {
        return this._http
            .post<ResponseResult>(this.serviceUri, item)
            .pipe(catchError(err => this.handleError(err, this._injector))).toPromise();
    }

    GetShort(idProvince: number) {
        const queryString = `${this.serviceUri}/GetShort?idProvince=${idProvince}`;
        return this.defaultGet(queryString);
    }


    ChangeDeleted(item: any): Promise<ResponseResult> {
        return this._http
            .post<ResponseResult>(this.serviceUri + '/ChangeDeleted/' + item.id, item)
            .pipe(catchError(err => this.handleError(err, this._injector))).toPromise();
    }
}

